import { ConnectionsSection } from '../../components/ConnectionsSection'
import { CreditsSection } from '../../components/CreditsSection'
import { TasksSection } from '../../components/TasksSection'

export function OverviewUsagePage () {
  return (
    <div className="flex flex-col gap-8">
      <TasksSection />
      <CreditsSection />
      <ConnectionsSection />
    </div>
  )
}
